import { forwardRef, StackProps, VStack } from '@chakra-ui/react';
import { FC, HTMLProps } from 'react';

import { Avatar } from '@/components/Avatar';
import {
  ChatMessageActions,
  ChatMessageWrapper,
} from '@/components/ui/shared/conversation/NestedChatMessage/NestedChatMessage.elements';
import useSession from '@/hooks/useSession';
import { IConversationMessage } from '@/utils/conversation/types';

import { NestedChatMessageBody } from './components/NestedChatMessageBody';
import { NestedChatMessageHeader } from './components/NestedChatMessageHeader';
import { NestedChatMessageReply } from './components/NestedChatMessageReply';
import { NestedChatMessageUpvote } from './components/NestedChatMessageUpvote';

export interface INestedChatMessageProps extends HTMLProps<StackProps> {
  message: IConversationMessage;
}

export const NestedChatMessage: FC<INestedChatMessageProps> = forwardRef(({ message }, ref) => {
  const { user } = useSession();
  const isReplyMessage = Boolean(message?.attributes?.parentMessageId);

  return (
    <ChatMessageWrapper
      borderLeft={isReplyMessage ? '1px solid #ccc' : 'none'}
      ml={isReplyMessage ? '28px' : '0px'}
      ref={ref}
    >
      <Avatar nameToDisplay={message.attributes.nameToDisplay} />

      <VStack w="full" alignItems="flex-start">
        <NestedChatMessageHeader message={message} />
        <NestedChatMessageBody message={message} />
        <ChatMessageActions>
          <NestedChatMessageUpvote message={message} mr={3} />
          {!isReplyMessage && (
            <NestedChatMessageReply
              message={message}
              messageAttributes={{
                nameToDisplay: user?.fullName,
                userEmail: user?.email,
                parentMessageId: message.sid,
              }}
            />
          )}
        </ChatMessageActions>
      </VStack>
    </ChatMessageWrapper>
  );
});
